document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll('.custom-tab');
  const tabContents = document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      const contentId = this.dataset.contentId;
      const content = document.getElementById(contentId);

      tabContents.forEach(function (content) {
        content.classList.remove('tabs-panelSelected-S6o');
      });

      tabs.forEach(function (tab) {
        tab.classList.remove('tabs-selected-MvP');
      });

      this.classList.add('tabs-selected-MvP');
      content.classList.add('tabs-panelSelected-S6o');
    });
  });

  $(".tabs-navigation--lK").on("scroll", function () {
    const cur = $(this).scrollLeft();
    if (cur === 0) {
      $('.tabs-navigation')
        .addClass('tabs-navigationGradientRight-6rc')
        .removeClass('tabs-navigationGradientLeft-g9D')
        .removeClass('tabs-navigationGradientBoth-g-a');
    } else {
      const max = $(this)[0].scrollWidth - $(this).parent().width();
      if (cur === max) {
        $('.tabs-navigation')
          .addClass('tabs-navigationGradientLeft-g9D')
          .removeClass('tabs-navigationGradientRight-6rc')
          .removeClass('tabs-navigationGradientBoth-g-a');
      } else {
        $('.tabs-navigation')
          .addClass('tabs-navigationGradientBoth-g-a')
          .removeClass('tabs-navigationGradientRight-6rc')
          .removeClass('tabs-navigationGradientLeft-g9D');
      }
    }
  });
  $(".tabs-navigation--lK").trigger("scroll");
});
